export default __webpack_public_path__ + "static/media/bg5.8129069f.jpg";